module.exports = __webpack_public_path__ + "img/cloud-check.adbb0447.svg";